export default __webpack_public_path__ + "static/media/botoes_genericos_05.30cd01eb.mp3";